import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 21l4 0","key":"svg-0"}],["path",{"d":"M10 21l0 -18","key":"svg-1"}],["path",{"d":"M10 4l9 4l-9 4","key":"svg-2"}]]

/**
 * IconPennant
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGVubmFudCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNOCAyMWw0IDAiIC8+CiAgPHBhdGggZD0iTTEwIDIxbDAgLTE4IiAvPgogIDxwYXRoIGQ9Ik0xMCA0bDkgNGwtOSA0IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/pennant
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPennant = createReactComponent('outline', 'pennant', 'Pennant', __iconNode);

export default IconPennant;